export const QORE_TALK_CATEGORIES = [
  'Technology', 'Business', 'Innovation', 'Entrepreneurship', 'AI', 'Web3',
  'Career', 'Leadership', 'Marketing', 'DevOps', 'Design', 'Manufacturing', 'Other'
];

export const FILTER_TABS = ['all', 'live', 'recorded', 'upcoming'];

export const USE_MOCKS = process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_MOCKS !== 'false';

export const mediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  const base = process.env.REACT_APP_API_BASE || 'https://qorenova-backend-production.up.railway.app';
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${base}${path}`;
};

export const hostDisplayName = (host) => {
  if (!host) return 'Unknown';
  if (typeof host === 'string') return host;
  return host.name || host.email || 'Unknown';
};

export const filterTalksByTab = (talks, tabIndex, liveRoomCount = 0) => {
  if (tabIndex === 0) return talks;
  if (tabIndex === 1) {
    return talks.filter(t => t.isLive || t.status === 'live');
  }
  if (tabIndex === 2) {
    return talks.filter(t => t.status === 'published' && !t.isLive);
  }
  if (tabIndex === 3) {
    const now = Date.now();
    return talks.filter(t => {
      if (t.status === 'scheduled') {
        return !t.scheduledFor || new Date(t.scheduledFor).getTime() > now;
      }
      return false;
    });
  }
  return talks;
};